import { render, staticRenderFns } from "./DashboardCustomerDetails.vue?vue&type=template&id=68e1456e&"
import script from "./DashboardCustomerDetails.vue?vue&type=script&lang=ts&"
export * from "./DashboardCustomerDetails.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardCustomerDetails.vue?vue&type=style&index=0&id=68e1456e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports